<!--
  One router-outlet for every child, so switching tabs never re-creates it.
  The four list tabs get the page frame, heading and tabs here; full-page
  children (details, import, builders, Add several) draw their own page.
-->
<div class="ct" [class.bk-page]="!!activeTab" [class.ct--bare]="!activeTab">
  @if (activeTab) {
    <header class="bk-page__head ct__head">
      <div class="bk-page__intro">
        <p class="bk-eyebrow">Audience</p>
        <h1 class="bk-page__title">{{ title }}</h1>
        <p class="bk-page__sub">{{ description }}</p>
      </div>

      <div class="bk-page__actions ct__actions">
        @if (activeTab === 'contacts') {
          <div
            *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'create-contacts' }"
            class="ct__add"
            (clickOutside)="onClickedOutside($event)"
          >
            <button
              #addTrigger
              id="ct-add-trigger"
              type="button"
              class="bk-btn bk-btn--primary"
              aria-haspopup="menu"
              [attr.aria-expanded]="showAddContactDropDown"
              [attr.aria-controls]="showAddContactDropDown ? 'ct-add-menu' : null"
              (click)="toggleContactDropDown($event)"
              (keydown)="onAddTriggerKeydown($event)"
            >
              <span class="bk-sym" aria-hidden="true">add</span>
              Add contacts
              <span class="bk-sym ct__caret" aria-hidden="true">expand_more</span>
            </button>

            @if (showAddContactDropDown) {
              <div
                #addMenu
                id="ct-add-menu"
                class="ct__menu"
                role="menu"
                aria-labelledby="ct-add-trigger"
                (keydown)="onAddMenuKeydown($event)"
              >
                <button type="button" role="menuitem" tabindex="-1" class="ct__item" (click)="OpenAddSingleContact()">
                  <span class="bk-sym" aria-hidden="true">person_add</span>
                  <span class="ct__item-text">
                    <span class="ct__item-title">One contact</span>
                    <span class="ct__item-hint">Fill in a short form</span>
                  </span>
                </button>
                <button type="button" role="menuitem" tabindex="-1" class="ct__item" (click)="goToCreateMultipleContactsPage()">
                  <span class="bk-sym" aria-hidden="true">group_add</span>
                  <span class="ct__item-text">
                    <span class="ct__item-title">Several at once</span>
                    <span class="ct__item-hint">Type a few contacts in rows</span>
                  </span>
                </button>
                <button
                  *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'import-contacts-csv-excel' }"
                  type="button"
                  role="menuitem"
                  tabindex="-1"
                  class="ct__item"
                  (click)="goToCsvUpload()"
                >
                  <span class="bk-sym" aria-hidden="true">upload_file</span>
                  <span class="ct__item-text">
                    <span class="ct__item-title">Import CSV or Excel</span>
                    <span class="ct__item-hint">Bring in a whole spreadsheet</span>
                  </span>
                </button>
              </div>
            }
          </div>
        }

        @if (activeTab === 'organizations') {
          <button
            *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'manage-contact-groups' }"
            type="button"
            class="bk-btn bk-btn--primary"
            (click)="openCreateOrganizationModal()"
          >
            <span class="bk-sym" aria-hidden="true">add</span>
            New organization
          </button>
        }

        @if (activeTab === 'tags') {
          <button
            *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'manage-contact-groups' }"
            type="button"
            class="bk-btn bk-btn--primary"
            (click)="openCreateTagModal()"
          >
            <span class="bk-sym" aria-hidden="true">add</span>
            New tag
          </button>
        }

        @if (activeTab === 'segments') {
          <button
            *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'manage-contact-groups' }"
            type="button"
            class="bk-btn bk-btn--primary"
            (click)="goToCreateSegmentPage()"
          >
            <span class="bk-sym" aria-hidden="true">add</span>
            New segment
          </button>
        }
      </div>
    </header>

    <app-routing-tab class="ct__tabs" [tabList]="tabs" />
  }

  <div class="ct__body">
    <feedback-card [message]="contactService.getErrorMsg" feedBackType="error" />
    <feedback-card [message]="contactService.getSuccessMsg" feedBackType="success" />
    <router-outlet />
  </div>
</div>

<!-- FORM CREATION MODALS -->
@if (showAddSingleContactModal) {
  <create-contact-form (closeModalEvent)="closeSingleContactModal()" />
}

@if (showAddOrganizationModal) {
  <create-organization-form (closeModal)="closeCreateOrganizationModal()" />
}

@if (showAddTag) {
  <create-tag-form-modal (closeModal)="closeCreateTagModal()" />
}
